import GithubRepositories from '@components/blog_examples/GithubRepositories';
import React from 'react';
export default {
  GithubRepositories,
  React
};